module.exports = __webpack_public_path__ + "img/craven.fa511fab.png";